export default __webpack_public_path__ + "static/media/planet-jupiter-internal.3087313d.svg";